(function () {
  function parseMap(panel) {
    var node = panel.querySelector('[data-ships-48h-map]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function isShips48h(map, variantId) {
    if (!variantId) return false;
    return map[String(variantId)] === true || map[variantId] === true;
  }

  function readVariantId(root) {
    var scope = root || document;
    var input =
      scope.querySelector('form[id^="product-form-"] input[name="id"]') ||
      document.querySelector('form[id^="product-form-"] input[name="id"]') ||
      document.querySelector('.productView input[name="id"]');
    return input ? String(input.value || '') : '';
  }

  function refreshDeliveryDates(deliveryEl, start, end) {
    if (!deliveryEl) return;
    deliveryEl.setAttribute('data-estimate-start', String(start));
    deliveryEl.setAttribute('data-estimate-end', String(end));
    if (typeof deliveryEl.refreshEstimates === 'function') {
      deliveryEl.refreshEstimates();
    }
  }

  function applyPanel(panel, variantId) {
    if (!panel) return;
    var map = parseMap(panel);
    var fast = isShips48h(map, variantId);
    var deliveryEl = panel.querySelector('delivery-time');
    var mtoRows = panel.querySelector('[data-ships-48h-mto]');
    var fastRows = panel.querySelector('[data-ships-48h-fast]');
    var mtoNote = panel.querySelector('[data-ships-48h-note-mto]');
    var fastNote = panel.querySelector('[data-ships-48h-note-fast]');
    var pill = document.querySelector('[data-ships-48h-pill]');

    panel.classList.toggle('is-ships-48h', fast);
    if (mtoRows) mtoRows.hidden = fast;
    if (fastRows) fastRows.hidden = !fast;
    if (mtoNote) mtoNote.hidden = fast;
    if (fastNote) fastNote.hidden = !fast;
    if (pill) pill.classList.toggle('is-hidden', !fast);

    if (deliveryEl) {
      var start = fast
        ? deliveryEl.getAttribute('data-estimate-start-48h')
        : deliveryEl.getAttribute('data-estimate-start-mto');
      var end = fast
        ? deliveryEl.getAttribute('data-estimate-end-48h')
        : deliveryEl.getAttribute('data-estimate-end-mto');
      if (start != null && end != null) {
        refreshDeliveryDates(deliveryEl, start, end);
      }
    }
  }

  function syncAll(variantId) {
    var id = variantId || readVariantId();
    document.querySelectorAll('[data-ships-48h-panel]').forEach(function (panel) {
      applyPanel(panel, id);
    });
  }

  function init() {
    if (!document.querySelector('[data-ships-48h-panel], [data-ships-48h-pill]')) return;
    syncAll();
    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!target) return;
        if (target.name === 'id' && target.matches('input')) {
          syncAll(String(target.value || ''));
          return;
        }
        if (target.closest && target.closest('variant-radios, variant-selects, combie-variants')) {
          window.requestAnimationFrame(function () {
            syncAll();
          });
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
